(function () {
  'use strict';

  var STORAGE_KEY = 'nutri_elixir_partner_attribution_v1';
  var COOKIE_KEY = 'ne_partner_ref';
  var WINDOW_DAYS = 30;
  var WINDOW_MS = WINDOW_DAYS * 24 * 60 * 60 * 1000;
  var CODE_PARAMS = ['ref', 'partner', 'promo'];

  function clean(value, maxLength) {
    return String(value || '').trim().replace(/[<>]/g, '').slice(0, maxLength || 100);
  }

  function normaliseCode(value) {
    var code = clean(value, 32).toUpperCase();
    return /^[A-Z0-9_-]{3,32}$/.test(code) ? code : '';
  }

  function readUrlCode(params) {
    for (var i = 0; i < CODE_PARAMS.length; i += 1) {
      var code = normaliseCode(params.get(CODE_PARAMS[i]));
      if (code) return code;
    }
    return '';
  }

  function referrerHost() {
    if (!document.referrer) return 'Direct';
    try {
      return clean(new URL(document.referrer).hostname, 100) || 'Direct';
    } catch (error) {
      return 'Direct';
    }
  }

  function save(attribution) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
    } catch (error) {}
    document.cookie = COOKIE_KEY + '=' + encodeURIComponent(attribution.code) +
      '; Max-Age=' + Math.floor(WINDOW_MS / 1000) + '; Path=/; SameSite=Lax; Secure';
  }

  function clearExpired() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {}
    document.cookie = COOKIE_KEY + '=; Max-Age=0; Path=/; SameSite=Lax; Secure';
  }

  function loadSaved() {
    try {
      var saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (!saved || !normaliseCode(saved.code) || Number(saved.expiresAt) <= Date.now()) {
        clearExpired();
        return null;
      }
      return saved;
    } catch (error) {
      clearExpired();
      return null;
    }
  }

  function cartAttributes(attribution) {
    return {
      'Partner code': attribution.code,
      'Partner captured at': attribution.capturedAt,
      'Partner landing page': attribution.landingPath,
      'Partner referrer': attribution.referrer,
      'Partner UTM source': attribution.utmSource,
      'Partner UTM medium': attribution.utmMedium,
      'Partner UTM campaign': attribution.utmCampaign,
      'Partner attribution model': 'Last valid click / 30 days'
    };
  }

  function syncCart(attribution) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({attributes: cartAttributes(attribution)})
    }).catch(function () {});
  }

  function announce(code) {
    if (document.getElementById('ne-partner-attribution-notice')) return;
    var isChinese = (document.documentElement.lang || '').toLowerCase().indexOf('zh') === 0;
    var notice = document.createElement('div');
    notice.id = 'ne-partner-attribution-notice';
    notice.setAttribute('role', 'status');
    notice.style.cssText = 'position:fixed;right:16px;bottom:16px;z-index:9999;display:flex;align-items:center;gap:12px;max-width:calc(100vw - 32px);padding:12px 14px;background:#0b4339;color:#fff;border-radius:4px;box-shadow:0 6px 24px rgba(0,0,0,.2);font:600 14px/1.4 system-ui,sans-serif';
    var message = document.createElement('span');
    message.textContent = isChinese ? '推广码 ' + code + ' 已记录（30天内有效）' : 'Partner code ' + code + ' recorded for 30 days';
    var close = document.createElement('button');
    close.type = 'button';
    close.setAttribute('aria-label', isChinese ? '关闭' : 'Close');
    close.textContent = '×';
    close.style.cssText = 'border:0;background:transparent;color:#fff;font-size:22px;line-height:1;cursor:pointer;padding:0';
    close.addEventListener('click', function () { notice.remove(); });
    notice.appendChild(message);
    notice.appendChild(close);
    document.body.appendChild(notice);
    window.setTimeout(function () { if (notice.parentNode) notice.remove(); }, 8000);
  }

  function run() {
    var params = new URLSearchParams(window.location.search);
    var urlCode = readUrlCode(params);
    var attribution = loadSaved();
    var isNew = false;

    if (urlCode) {
      var now = Date.now();
      attribution = {
        code: urlCode,
        capturedAt: new Date(now).toISOString(),
        expiresAt: now + WINDOW_MS,
        landingPath: clean(window.location.pathname + window.location.search, 250),
        referrer: referrerHost(),
        utmSource: clean(params.get('utm_source'), 100),
        utmMedium: clean(params.get('utm_medium'), 100),
        utmCampaign: clean(params.get('utm_campaign'), 100)
      };
      save(attribution);
      isNew = true;
    }

    if (!attribution) return;
    syncCart(attribution);

    if (isNew) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'partner_attribution_captured',
        partner_code: attribution.code,
        attribution_model: 'last_valid_click_30_days'
      });
      announce(attribution.code);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, {once: true});
  } else {
    run();
  }
}());
